import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from "@angular/core";
import { FormControl, Validators, FormGroup, FormBuilder } from "@angular/forms";
import { Button } from "app-core";
import { DoctorsDummyDataService } from "app-service";
import { Subject, takeUntil } from "rxjs";

import ButtonType = Data.Core.ButtonType;

@Component({
  selector: 'app-dummy-data-doctors',
  templateUrl: './doctors.component.html',
  styleUrls: ['./doctors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [DoctorsDummyDataService]
})
export class DummyDataDoctorsComponent {
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  public usersControl = new FormControl('', Validators.required);
  public usersForm!: FormGroup;
  public userCount: number = 0;
  public clinicCount: number = 0;
  public createUserButton: Button = new Button({
    label: 'Create Users',
    type: ButtonType.button,
    action: () => this.createDummyDoctors(
      Number(this.usersControl.value)
    ),
    disabled: () => !this.usersForm!.valid,
  });
  public createClinicProfileButton: Button = new Button({
    label: 'Create Clinic Profiles',
    type: ButtonType.button,
    action: () => this.createClinicProfiles(this.userCount),
    disabled: () => false,
  });
  public createKeywordsButton: Button = new Button({
    label: 'Update Keywords',
    type: ButtonType.button,
    action: () => this.updateKeywords(this.userCount),
    disabled: () => false,
  });
  public createExpiredSubscriptionButton: Button = new Button({
    label: 'Create Expired Subscriptions',
    type: ButtonType.button,
    action: () => this.createExpiredSubscription(this.userCount),
    disabled: () => false,
  });

  public constructor(
    public readonly _cdRef: ChangeDetectorRef,
    private readonly _formBuilder: FormBuilder,
    private readonly _doctorsDummyDataService: DoctorsDummyDataService
  ) {
    this.usersForm = this._formBuilder.group([this.usersControl]);
  }

  public ngOnInit(): void {
    this.getDummyDoctorsCount();
    this.getDummyClinicsCount();
  }

  private createDummyDoctors(numberOfDoctors: number): void {
    this._doctorsDummyDataService.createDummyDoctors(numberOfDoctors)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        () => { },
        () => { },
        () => {
          this.getDummyDoctorsCount();
        }
      );
  }

  private getDummyDoctorsCount(): void {
    this._doctorsDummyDataService.getDummyDoctorsCount()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (count: any) => {
          this.userCount = count.count;
          this._cdRef.markForCheck();
        }
      );
  }
  
  private getDummyClinicsCount(): void {
    this._doctorsDummyDataService.getDummyClinicsCount()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (count: any) => {
          this.clinicCount = count.count;
          this._cdRef.markForCheck();
        }
      );
  }

  private updateKeywords(numberOfUsers: number): void {
    this._doctorsDummyDataService.updateKeywords(numberOfUsers)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe();
  }

  private createClinicProfiles(numberOfUsers: number): void {
    this._doctorsDummyDataService.createDummyClinics(numberOfUsers)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe();
  }

  private createExpiredSubscription(numberOfUsers: number): void {
    this._doctorsDummyDataService.createExpiredSubscription(numberOfUsers)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe();
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
